import React from 'react'
import { Icon } from './MenuGrid.elements'

type Props = {
  className?: string
}

export const MenuGridIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <rect x="9" y="15" width="11" height="4" rx=".649" fill="currentColor" />
    <rect x="4" y="15" width="4" height="4" rx=".649" fill="currentColor" />
    <rect x="9" y="10" width="11" height="4" rx=".649" fill="currentColor" />
    <rect x="4" y="10" width="4" height="4" rx=".649" fill="currentColor" />
    <rect x="9" y="5" width="11" height="4" rx=".649" fill="currentColor" />
    <rect x="4" y="5" width="4" height="4" rx=".649" fill="currentColor" />
  </Icon>
)
